export default "<button title=\"{{'BUTTONS.SEARCH' | translate}}\" class=\"btn btn-primary\" (click)=\"search()\">{{'BUTTONS.SEARCH' | translate}}</button>";